/**
 * Tarjeta y encabezado de sección del WhatsApp oficial. Mismo estilo que `SecTitulo` de
 * `CampanaDetallePage.tsx`: la jerarquía la da el título, no una caja más.
 */

import type { ReactNode } from "react";

export function SecTitulo({ titulo, sub, right }: { titulo: string; sub?: string; right?: ReactNode }) {
  return (
    <header className="flex items-end justify-between gap-3 mb-5 flex-wrap">
      <div className="min-w-0">
        <h2 className="text-base font-semibold text-slate-900 tracking-tight">{titulo}</h2>
        {sub && <p className="text-xs text-slate-400 mt-0.5">{sub}</p>}
      </div>
      {right}
    </header>
  );
}

export function Tarjeta({ titulo, sub, right, children, className = "" }: {
  titulo?: string; sub?: string; right?: ReactNode; children?: ReactNode; className?: string;
}) {
  return (
    <section className={`rounded-2xl border border-slate-100 bg-white p-6 shadow-sm ${className}`}>
      {titulo && <SecTitulo titulo={titulo} sub={sub} right={right} />}
      {children}
    </section>
  );
}

export default Tarjeta;
